import api from "../../api/api";
import isPlainObject from 'lodash/isPlainObject';

// axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// 1. `/api/cart/{organization_id}/{branch_id}/{{id}}`
// 2. `/api/stock/{organization_id}/{branch_id}/`
// 3. `/api/order/{organization_id}/{branch_id}/`
// 4. `/api/payment_processor/{organization_id}/{branch_id}/`
// 5. `/api/invoice/{organization_id}/{branch_id}/`
// 6. `/api/line_item/{organization_id}/{branch_id}/`

const state = {
    cart: {},
    scanned_cart: [],
    cart_type: "branch",
    scan_mode: false,
    scan_to_paste:false,
    oe_mode: false,
    invoice_mode: false,
    sku_mode: false,
    in_stock_only: true,
    active_company: 0,
    active_company_low_stock:0,
    count_order_mode: false,
    stock: {},
    order: {},
    payment_processor: {},
    invoice: {},
    line_items: [],
    stocks: {},
    similar_stock: [],
    source_of_truth: [],
    pos_transactions: [],
    pos_transaction_by_id: [],
    searched_transactions: [],
    // Filter values for inventory search
    filterCategoryA: null,
    filterCategoryB: null,
    filterCategoryC: null,
    filterVehicles: null,
    // Filter options for dropdowns (populated by search context)
    filterVehiclesOptions: [],
    filterCategoryAOptions: [],
    qty_min: null,
    qty_max: null,
    qty_operator: 'between',
};

const mutations = {
    GET_SEARCHED_TRANSACTIONS(state, payload) {
        state.searched_transactions = payload;
    },
    SET_POS_TRANSACTIONS(state, payload) {
        state.pos_transactions = payload;
    },

    GET_POS_TRANSACTION_BY_ID(state, payload) {
        state.pos_transaction_by_id = payload;
    },

    update_cart(state, payload) {
        state.cart = payload;
    },
    update_stock(state, payload) {
        state.stock = payload;
    },
    update_order(state, payload) {
        state.order = payload;
    },
    update_payment_processor(state, payload) {
        state.payment_processor = payload;
    },
    update_invoice(state, payload) {
        state.invoice = payload;
    },
    update_line_items(state, payload) {
        // Ensure payload is always an array
        state.line_items = Array.isArray(payload) ? payload : [];
    },
    reset_cart(state) {
        state.line_items = [];
        state.source_of_truth = [];
    },
    reset_scan_count(state) {
        state.scanned_cart = [];
    },
    SCAN_TO_CART(state, payload) {
        //update to use lodash instead
        let found = false;
        if (typeof state.scanned_cart === "string") {
            state.scanned_cart = [];
        }
        let scan_reset = state.scanned_cart;
        state.scanned_cart = false;
        state.scanned_cart = scan_reset;
        state.scanned_cart.forEach((e) => {
            if (e.id == payload.id) {
                let newamount = parseInt(e.amount) + 1;
                e.amount = newamount;
                e.checkCount = newamount;
                found = true;
            }
        });
        if (found == false) {
            payload.amount = 1;
            payload.checkCount = 0;
            state.scanned_cart.push(payload);
        }
    },
    

    ADD_LINE_ITEM(state, payload) {
        // Guard: prior verifyStockLevels bugs could leave line_items as false/object
        if (!Array.isArray(state.line_items)) {
            state.line_items = [];
        }
        if (!Array.isArray(state.source_of_truth)) {
            state.source_of_truth = [];
        }

        let found = false;

        // Bail early if payload is not a valid object
        if (!isPlainObject(payload) || Object.keys(payload).length === 0) {
            console.warn("Invalid payload in ADD_LINE_ITEM", payload);
            return;
        }

        state.line_items.forEach((e) => {
            if (e.id == payload.id) {
                e.amount = parseInt(e.amount) + 1;
                found = true;
            }
        });
        if (!found) {
            state.line_items.push(payload);
            state.source_of_truth.push(payload);
        }
    },

    update_lineitem_stock(state, payload) {
        // Never replace cart with false/null/object — that breaks addCart reduce/find
        state.line_items = Array.isArray(payload) ? payload : [];
    },
    remove_line_items(state, payload) {
        var index = state.line_items.indexOf(payload);
        if (index > -1) {
            state.line_items.splice(index, 1);
        }
        
        var truth_index = state.source_of_truth.indexOf(payload);
        if (truth_index > -1) {
            state.source_of_truth.splice(truth_index, 1);
        }
    },

    // Mobile cart mutations
    UPDATE_LINE_ITEM(state, { index, item }) {
        if (state.line_items[index]) {
            state.line_items.splice(index, 1, item);
        }
        
        // Also update source of truth
        const truthIndex = state.source_of_truth.findIndex(truthItem => truthItem.id === item.id);
        if (truthIndex > -1) {
            state.source_of_truth.splice(truthIndex, 1, item);
        }
    },

    REMOVE_LINE_ITEM(state, index) {
        if (state.line_items[index]) {
            const removedItem = state.line_items.splice(index, 1)[0];
            
            // Also remove from source of truth
            const truthIndex = state.source_of_truth.findIndex(truthItem => truthItem.id === removedItem.id);
            if (truthIndex > -1) {
                state.source_of_truth.splice(truthIndex, 1);
            }
        }
    },
    clear_scan_count(state) {
        state.scanned_cart = [];
    },
    remove_scanned_item(state, payload) {
        var index = state.scanned_cart.indexOf(payload);
        if (index > -1) {
            state.scanned_cart.splice(index, 1);
        }
    },
    cart_type(state, payload) {
        state.cart_type = payload;
    },
    scan_mode(state, payload) {
        state.scan_mode = payload;
    },
    oe_mode(state, payload) {
        state.oe_mode = payload;
    },
    invoice_mode(state, payload) {
        state.invoice_mode = payload;
    },
    sku_mode(state, payload) {
        state.sku_mode = payload;
    },
    scan_to_paste(state, payload) {
        state.scan_to_paste = payload;
    },
    in_stock_only(state, payload) {
        state.in_stock_only = payload;
    },
    active_company(state, payload) {
        state.active_company = payload;
    },
    active_company_low_stock(state, payload) {
        state.active_company_low_stock = payload;
    },
    count_order_mode(state, payload) {
        state.count_order_mode = payload;
    },
    allStockHistory(state, payload){
        state.stocks = payload;
    },
    fetch_user_branch_stock_history(state, payload){
        state.stocks = payload;
    },
    fetch_by_inventory_and_branch(state, payload){
        state.similar_stock = payload;
    },
    // Filter mutations
    SET_FILTER_CATEGORY_A(state, payload) {
        state.filterCategoryA = payload;
    },
    SET_FILTER_CATEGORY_B(state, payload) {
        state.filterCategoryB = payload;
    },
    SET_FILTER_CATEGORY_C(state, payload) {
        state.filterCategoryC = payload;
    },
    SET_FILTER_VEHICLES(state, payload) {
        state.filterVehicles = payload;
    },
    // Filter options mutations
    SET_FILTER_VEHICLES_OPTIONS(state, payload) {
        state.filterVehiclesOptions = payload;
    },
    SET_FILTER_CATEGORY_A_OPTIONS(state, payload) {
        state.filterCategoryAOptions = payload;
    },
    SET_QTY_MIN(state, payload) {
        state.qty_min = payload;
    },
    SET_QTY_MAX(state, payload) {
        state.qty_max = payload;
    },
    SET_QTY_OPERATOR(state, payload) {
        state.qty_operator = payload;
    },
};

const actions = {

    async search_transactions(context, { keyword, onlineFilter = 0 }) {
        let payload = {};
        const params = onlineFilter !== 0 ? `?online_filter=${onlineFilter}` : '';
        await api.instance.get("/api/order/search_transactions/" + keyword + params).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("GET_SEARCHED_TRANSACTIONS", payload)
        })
    },

    async validateInvoiceNumber(context, payload) {
        try {
            const response = await api.instance.post("/api/order/validate-invoice-number", {
                invoice_number: payload.invoice_number,
                exclude_order_id: payload.exclude_order_id || null
            });
            return response.data;
        } catch (error) {
            console.error('Invoice validation error:', error);
            throw error;
        }
    },

    async get_full_transaction_data_by_id(context, order_id) {
        let payload = {};
        await api.instance.get("/api/order/get_full_transaction_data_by_id/" + order_id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("GET_POS_TRANSACTION_BY_ID", payload);
            
        });
    },

    async get_pos_transactions(context, path = "order/get_pos_transactions") {
        let payload = {};
        await api.instance.get("/api/" + path).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("SET_POS_TRANSACTIONS", payload);
        });
    },

    async confirm_payment(contex, payload) {
        await api.instance.post("/api/order/confirm_payment", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async confirm_transfer(contex, payload) {
        await api.instance.post("/api/order/confirm_stock_transfer", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async add_funds_to_wallet(contex, payload) {
        await api.instance.post("/api/order/add_funds_to_wallet", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async issue_refund(contex, payload) {
        
        await api.instance.post("/api/refund/issue_refund", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async complete_packing(contex, payload) {
        await api.instance.post("/api/order/complete_packing", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async complete_receiving(contex, payload) {
        await api.instance.post("/api/order/complete_receiving", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async complete_distribution(contex, payload) {
        await api.instance.post("/api/order/complete_distribution", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async fetch_all_pos(context, path = "cart") {
        let payload = {};
        await api.instance.get("/api/" + path).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async fetch_single(context, path = "cart", payload) {
        await api.instance.get("/api/" + path + "/" + payload.id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async create_pos(context, path = "cart", payload) {
        await api.instance.post("/api/" + path + "/", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async update_pos(context, path = "cart", payload) {
        await api.instance.put("/api/" + path + "/" + payload.id, payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async delete_pos(context, path = "cart", payload) {
        await api.instance.delete("/api/" + path + "/" + payload.id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async verifyStockLevels(context) {
        let active_company = context.rootState.Pos.active_company ? context.rootState.Pos.active_company.id : null;
        const lineItems = Array.isArray(context.state.line_items) ? context.state.line_items : [];
        if (lineItems.length === 0) {
            context.commit("update_lineitem_stock", []);
            return;
        }
        try {
            const res = await api.instance.post("/api/stock/verifyStockLevels", {
                line_items: lineItems,
                branch_id: active_company,
            });
            // Keep existing cart if API returns nothing useful
            if (Array.isArray(res.data)) {
                context.commit("update_lineitem_stock", res.data);
            }
        } catch (error) {
            console.error("verifyStockLevels failed:", error);
        }
    },
    async allStockHistory(context) {
        let payload = {};
        await api.instance
            .get("/api/stock_history/fetch_user_branch_stock_history")
            .then((res) => {
                if (!res.data || res.data.length == 0) {
                    payload = false;
                } else {
                    payload = res.data;
                }
                context.commit("allStockHistory", payload);
            });
    },
    async fetch_user_branch_stock_history(context) {
        let payload = {};
        await api.instance
            .get("/api/stock_history/fetch_user_branch_stock_history")
            .then((res) => {
                if (!res.data || res.data.length == 0) {
                    payload = false;
                } else {
                    payload = res.data;
                }
                context.commit("allStockHistory", payload);
            });
    },
    async search_branch_stock_history(context, payload) {
        const { entity, dates, partNumber, entityType, selectedTypes } = payload;
        
        // Ensure entity is a string/number, not an object
        const entityId = typeof entity === 'object' ? entity?.id : entity;
      
        const typeParams = selectedTypes.length > 0 ? `&types=${selectedTypes.join(',')}` : '';
      
        await api.instance
          .get(`/api/stock_history/search_branch_stock_history?entity=${entityId}&dates=${dates}&partNumber=${partNumber}&entityType=${entityType}${typeParams}`)
          .then((res) => {
            let stockHistoryData;
            if (!res.data || res.data.length === 0) {
              stockHistoryData = false;
            } else {
              stockHistoryData = res.data;
            }
            context.commit("allStockHistory", stockHistoryData);
        });
    },
    async fetch_by_inventory_and_branch(context, payload) {
        try {
          const response = await api.instance.get(`/api/stock_history/fetch_by_inventory_and_branch?inventory_id=${payload.inventory_id}&branch_id=${payload.branch_id}`);
          if (!response.data || response.data.length === 0) {
            return false;
          } else {
            return response.data;
          }
        } catch (error) {
          // Handle error if needed
          console.error(error);
          return null;
        }
    },



    async fetch_import_price_histories(context, payload) {
        try {
          
          const response = await api.instance.get(`/api/fetch_import_price_histories?system_number=${payload.system_number}&branch_id=${payload.branch_id}`);
          if (!response.data || response.data.length === 0) {
            return false;
          } else {
            return response.data;
          }
        } catch (error) {
          // Handle error if needed
          console.error(error);
          return null;
        }
    },









    //the main ones we will delete the above for the new backend pattern
    addLineItem({commit}, payload) {
        commit("ADD_LINE_ITEM", payload);
    },
    scantocartbootup(context, e) {
        context.commit("SCAN_TO_CART", e);
    },
    reset_scan_count(context) {
        context.commit("reset_scan_count");
    },
    async scantocart(context, order) {
        let payload = {};
        await api.instance.get("/api/inventory/system_number/" + order).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data[0];
            }
            context.commit("SCAN_TO_CART", payload);
        });
    },
    clearCart({commit}) {
        commit("reset_cart");
    },
    removeLineItem({commit}, payload) {
        commit("remove_line_items", payload);
    },
    removeScannedItem({commit}, payload) {
        commit("remove_scanned_item", payload);
    },
    async createOrder({commit}, payload) {
        try {
            const response = await api.instance.post("/api/order", payload);
            
            if (!response.data || response.data.length == 0) {
                throw new Error("No response data received from server");
            }
            
            const orderData = response.data;
            
            // Commit the order data to store
            commit("update_order", orderData);
            commit("reset_cart");

            return orderData;
            
        } catch (error) {
            // Log the error for debugging
            console.error('Store createOrder error:', error);
            
            // Re-throw the error so the component can handle it
            throw error;
        }
    },
    async logCount({commit}, payload) {
        await api.instance.post("/api/stock/scanToUpdate", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            commit("clear_scan_count");
        });
    },
    cart_type({commit}, payload) {
        commit("cart_type", payload);
    },
    scan_to_paste({commit}, payload) {
        commit("scan_to_paste", payload);
    },
    scan_mode({commit}, payload) {
        commit("scan_mode", payload);
    },
    oe_mode({commit}, payload) {
        commit("oe_mode", payload);
    },
    invoice_mode({commit}, payload) {
        commit("invoice_mode", payload);
    },
    sku_mode({commit}, payload) {
        commit("sku_mode", payload);
    },
    in_stock_only({commit}, payload) {
        commit("in_stock_only", payload);
    },
    active_company({commit}, payload) {
        commit("active_company", payload);
    },
    active_company_low_stock({commit},payload){
        commit("active_company_low_stock",payload)
    },
    count_order_mode({commit}, payload) {
        commit("count_order_mode", payload);
    },
};

const getters = {
    cart: (state) => state.cart,
    stock: (state) => state.stock,
    order: (state) => state.order,
    payment_processor: (state) => state.payment_processor,
    invoice: (state) => state.invoice,
    line_items: (state) => state.line_items,
    cart_type: (state) => state.cart_type,
    scan_mode: (state) => state.scan_mode,
    oe_mode: (state) => state.oe_mode,
    invoice_mode: (state) => state.invoice_mode,
    sku_mode: (state) => state.sku_mode,
    scan_to_paste: (state) => state.scan_to_paste,
    active_company: (state) => state.active_company,
    active_company_low_stock: () => state.active_company_low_stock,
    in_stock_only: (state) => state.in_stock_only,
    scanned_cart: (state) => state.scanned_cart,
    count_order_mode: (state) => state.count_order_mode,
    allStockHistory: (state) => state.stocks,
    fetch_user_branch_stock_history: (state) => state.stocks,
    fetch_by_inventory_and_branch: (state) => state.stocks,
    source_of_truth: (state) => state.source_of_truth,

    get_pos_transactions: (state) => state.pos_transactions,
    get_pos_transaction_by_id: (state) => state.pos_transaction_by_id,
    get_searched_transactions: (state) => state.searched_transactions,
    // Filter options getters
    filterVehiclesOptions: (state) => state.filterVehiclesOptions,
    filterCategoryAOptions: (state) => state.filterCategoryAOptions,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
